import axios from 'axios';
import ApiService from './ApiService';

const getDynamicTrade = async () => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching dynamic trade:", error);
        throw error.response || error;
    }
}


const getDynamicTradeByClientId = async (clientId) => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic/fetch/${clientId}`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching dynamic trade:", error);
        throw error.response || error;
    }
}

const getDynamicTradeByTradeId = async (tradeId) => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic/fetch?tradeId=${tradeId}`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching dynamic trade:", error);
        throw error.response || error;
    }
}


const getAllDynamicTrades = async () => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic/fetch/all`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching all dynamic trades:", error);
        throw error.response || error;
    }
}

const createDynamicTrade = async (payload) => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic`;
        const response = await axios.post(route, payload, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating dynamic trade:", error);
        throw error.response || error;
    }
};

const updateDynamicTrade = async (payload) => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic`;
        const response = await axios.put(route, payload, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating dynamic trade:", error);
        throw error.response || error;
    }
};

const startJob = async () => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic/job/start`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating dynamic trade:", error);
        throw error.response || error;
    }
};

const stopJob = async () => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic/job/stop`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating dynamic trade:", error);
        throw error.response || error;
    }
};

const getJobStatus = async () => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic/job/status`;
        const response = await axios.get(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting job status:", error);
        throw error.response || error;
    }
};

const getDynamicTradeHistory = async (payload, page, size) => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic/history?page=${page}&size=${size}`;
        const response = await axios.post(route, payload, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error getting dynamic trade history:", error);
        throw error.response || error;
    }
};


const deleteDynamicTrade = async (trade) => {
    try {
        const route = `${ApiService.restUrl()}/trade/dynamic?tradeId=${trade.id}`;
        const response = await axios.delete(route, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting dynamic trade:", error);
        throw error.response || error;
    }
};

const DynamicTradeService = {
    getDynamicTrade,
    getDynamicTradeByClientId,
    getDynamicTradeByTradeId,
    getAllDynamicTrades,
    createDynamicTrade,
    updateDynamicTrade,
    startJob,
    stopJob,
    getJobStatus,
    getDynamicTradeHistory,
    deleteDynamicTrade
};

export default DynamicTradeService;